import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Link, Router,Switch } from 'react-router-dom'
import config from 'react-global-configuration';
import configuration from './config.js';
import LoginApp from './components/LoginApp'
import CardApp from './components/CardApp'

import SignUpApp from './components/SignUpApp'
import RegulationApp from './components/RegulationApp'
import AboutApp from './components/AboutApp'
import MemberApp from './components/member/MemberApp'
import PaidApp from './components/member/PaidApp'
import CalendarApp from './components/member/CalendarApp'

import TopApp from './components/TopApp'



config.set(configuration);

class App extends React.Component{


render(){
return(
     <div>
        <Route exact path='/' component={TopApp} />
        <Route exact path='/about' component={AboutApp} />
        <Route exact path='/login' component={LoginApp} />
        <Route exact path='/payment' component={CardApp} />

        <Route exact path='/signup' component={SignUpApp} />
        <Route exact path='/regulation' component={RegulationApp} />
        <Route exact path='/member/dashboard' component={CalendarApp} />
        <Route exact path='/member' component={MemberApp} />
        <Route exact path='/member/paid' component={PaidApp} />
        <Route exact path='/member/calendar' component={CalendarApp} />

      </div>
)}}

ReactDOM.render(
  (<BrowserRouter  basename="club"><App /></BrowserRouter>),
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js